(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advent-calendar-selector"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('calendar-gallery')) {
  customElements.define('calendar-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const track = this.querySelector('.tac-calendar-gallery__track');
      const slides = Array.from(track.children);
      const count = this.querySelector('.tac-calendar-gallery__count');
      const previous = this.querySelector('[data-direction="-1"]');
      const next = this.querySelector('[data-direction="1"]');
      const update = () => {
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        count.textContent = (index + 1) + ' / ' + slides.length;
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
      };
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        const target = Math.max(0, Math.min(slides.length - 1, index + Number(button.dataset.direction)));
        track.scrollTo({left:target * track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
